import react from 'react'

import './Footer.scss'

const Footer = _ => {

    return (
        <footer>
            <p>
                © Danilo Portfolio - 2025
            </p>
        </footer>
    )
}

export default Footer